import styled, { css } from 'styled-components';
import { Ellipsis } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

interface Props {
  disabled?: boolean;
}

export const Wrapper = styled('li')<Props>`
  cursor: ${({ disabled }) => (disabled ? `auto` : `pointer`)};
  position: relative;

  color: white;
  text-align: left;
  margin: 0 -${({ theme }) => theme.x3spacePx}px;
  padding: ${({ theme }) => theme.x1spacePx + 2}px;
  ${media.lgUp`
    padding-top: ${({ theme }) => theme.x1spacePx - 1}px;
    padding-bottom: ${({ theme }) => theme.x1spacePx - 1}px;
  `};
  padding-left: ${({ theme }) => theme.x3spacePx}px;
  padding-right: ${({ theme }) => theme.x17spacePx}px;
  border-top: solid 1px ${({ theme }) => theme.color.paper};
  background: ${({ theme }) => theme.color.white};
  text-transform: capitalize;
  height: ${({ theme }) => theme.x8spacePx}px;
  h4,
  p {
    ${({ disabled }) =>
      disabled &&
      css`
        opacity: 0.3;
      `}
  }

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        background: ${({ theme }) => theme.color.spaceGrayRGBA(0.05)};
      }
    `}
`;

export const Title = styled('h4')`
  ${({ theme }) => theme.typography.baseStrong}
  color: ${({ theme }) => theme.color.spaceGray};
  margin: 0;
  text-transform: none;
  ${Ellipsis};
`;

export const Details = styled.p`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.spaceGray};
  opacity: 0.5;
  margin: 0;
  ${Ellipsis};
`;

export const Add = styled('div')`
  position: absolute;
  right: ${({ theme }) => theme.x3spacePx}px;
  top: ${({ theme }) => theme.x2spacePx}px;
`;
